/**
 * Data transformation utilities for consistent data formatting
 */

/**
 * Transforms entry data from API to application format
 * @param {Object} item - Entry from API
 * @returns {Object} Transformed entry
 */
export const transformEntry = (item) => ({
  ...item,
  date: item.date ? new Date(item.date) : new Date(),
  billet: item.billet || 0,
  money: item.money || 0,
  total_calculated: item.total_calculated || (item.billet || 0) + (item.money || 0)
});

/**
 * Transforms credit data from API to application format
 * @param {Object} item - Credit from API
 * @returns {Object} Transformed credit
 */
export const transformCredit = (item) => ({
  ...item,
  date: item.date ? new Date(item.date) : new Date()
});

/**
 * Transforms multiple entries
 * @param {Array} entries - Array of entries from API
 * @returns {Array} Array of transformed entries
 */
export const transformEntries = (entries) => {
  if (!Array.isArray(entries)) return [];
  return entries.map(transformEntry);
};

/**
 * Transforms multiple credits
 * @param {Array} credits - Array of credits from API
 * @returns {Array} Array of transformed credits
 */
export const transformCredits = (credits) => {
  if (!Array.isArray(credits)) return [];
  return credits.map(transformCredit);
};

